export default {
  comparison: {
    aiCommand: {
      eyebrow: 'Centro de comando IA de Geofleet',
      title: 'Automatización agéntica desde un solo centro de comando',
      intro:
        'Mientras otros se quedan en mapas o reglas básicas de despacho, el centro de comando IA de Geofleet orquesta asignación automática de transportistas, asignación automática de conductores, planificación agéntica de rutas y alertas e inteligentes notificaciones, con agentes de IA actuando por ti desde una sola torre de control.',
      ctaFeatures: 'Explorar agentes IA y automatización',
      capabilities: {
        agents: {
          title: 'Agentes IA',
          body: 'Flujos agénticos en el centro de comando resuelven excepciones, reasignan trabajo y coordinan logística multietapa sin esperar a un despachador humano.',
        },
        carrier: {
          title: 'Asignación automática de transportistas',
          body: 'La IA empareja cada envío con el transportista adecuado según capacidad, coste, SLA, histórico de ruta y condiciones en vivo, de forma continua.',
        },
        driver: {
          title: 'Asignación automática de conductores',
          body: 'Los conductores se asignan y reequilibran automáticamente desde la misma torre que los transportistas, con proximidad, habilidades, turnos y carga en un solo modelo.',
        },
        routes: {
          title: 'Planificación agéntica de rutas',
          body: 'Las rutas se planifican y reprograman con ML que reacciona al tráfico, nuevos pedidos, intentos fallidos y restricciones de hub, muy más allá de archivos estáticos.',
        },
        alerts: {
          title: 'Alertas y notificaciones IA',
          body: 'Alertas proactivas por riesgo de SLA, retrasos, falta de capacidad y excepciones, priorizadas por la IA para actuar primero en lo importante.',
        },
        tower: {
          title: 'Un solo centro de comando',
          body: 'Todo corre en un único centro de comando Geofleet: sin parches de herramientas aisladas para rutas, despacho, socios y comunicaciones.',
        },
      },
    },
  },
};
